<template>
    <div>
        <v-toolbar title="Jobs" density="compact" color="primary" class="mb-2">
        </v-toolbar>

        <v-tabs v-model="tab" align-tabs="start">
            <v-tab v-for="taskType in taskTypes" :key="taskType.id" :value="taskType.id"
                @click="fetchJobs(taskType.id)" color="primary">
                {{ taskType.name }}
            </v-tab>
        </v-tabs>

        <v-window v-model="tab">
            <JobsView :jobs_list="jobs" />
        </v-window>

    </div>
</template>

<script>
import JobsView from './JobsView.vue';
import taskEngineService from '../../services/taskEngineService';
import { TASK_TYPES } from '../../taskEngine/constants';
export default {
    name: "AllJobsList",
    data() {
        return {
            jobs: [],
            taskTypes: [],
            tab: null,
            TASK_TYPES
        }
    },
    components: {
        JobsView,
    },
    methods: {
        async fetchJobs(taskTypeId) {
            let res = await taskEngineService.getJobsbyTaskTypeId(taskTypeId);
            this.jobs = res.data || [];
        },
    },
    async created() {
        this.taskTypes = Object.values(this.TASK_TYPES);
        this.tab = this.taskTypes[0].id;
        this.fetchJobs(this.taskTypes[0].id);
    }
}
</script>